import React from "react";
import { ActionIcon, Tooltip, useMantineColorScheme } from "@mantine/core";
import { useTrans } from "core";
import { MSIcon } from "components";
const ModeSwitcher = () => {
  const trans = useTrans();
  const { colorScheme, setColorScheme } = useMantineColorScheme();
  const toggleDark = () =>
    setColorScheme((p) => (p === "dark" ? "light" : "dark"));
  const isDark = colorScheme === "dark";
  return (
    <div>
      <Tooltip label={trans.t("drawer.switchMode")}>
        <ActionIcon
          size={36}
          radius={"md"}
          variant="subtle"
          color="secondary"
          onClick={toggleDark}
        >
          <MSIcon name={isDark ? "WeatherSunny" : "WeatherNight"} />
        </ActionIcon>
      </Tooltip>
    </div>
  );
};

export default ModeSwitcher;
